import { useState } from 'react';
import { Link } from 'react-router-dom';

const STEPS = [
  {
    title: 'Take an assessment',
    body: 'Complete clinically validated PHQ-9 and GAD-7 screeners in about two minutes. Your results help match you with the right support — privately.',
    cta: { label: 'Start free assessment', to: '/assessment' },
    icon: '📋',
  },
  {
    title: 'Find your therapist',
    body: 'Choose by specialty, language, or the city they call home, then open a profile to see the fee and the next open hour.',
    cta: { label: 'Browse therapists', to: '/therapists' },
    icon: '🤝',
  },
  {
    title: 'Start your sessions',
    body: 'Book video, voice, or chat sessions in naira. Pay securely, join from web or mobile, and track your progress over time.',
    cta: { label: 'Create account', to: '/register' },
    icon: '💬',
  },
] as const;

export function HowItWorksStepper() {
  const [active, setActive] = useState(0);
  const step = STEPS[active]!;

  return (
    <div className="how-it-works">
      <div className="how-it-works-tabs" role="tablist" aria-label="How Mylighthouse works">
        {STEPS.map((item, index) => (
          <button
            key={item.title}
            type="button"
            role="tab"
            aria-selected={active === index}
            className={`how-it-works-tab ${active === index ? 'is-active' : ''}`}
            onClick={() => setActive(index)}
          >
            <span className="how-it-works-tab-num">{index + 1}</span>
            <span className="how-it-works-tab-label">{item.title}</span>
          </button>
        ))}
      </div>
      <div className="how-it-works-panel card" role="tabpanel">
        <span className="text-3xl" aria-hidden>
          {step.icon}
        </span>
        <h3 className="mt-3 text-xl font-bold text-gray-900">{step.title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-gray-600">{step.body}</p>
        <Link to={step.cta.to} className="btn-primary mt-5 inline-flex text-sm">
          {step.cta.label} →
        </Link>
      </div>
    </div>
  );
}
